// @flow
import { call, put, takeEvery } from 'redux-saga/effects';
import { setAvailableOptions } from './';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import { injectMockRoamingCatalogOptions } from '../../lib/mockRoamingOptions';
import type { AvailableOptionActionType } from './actions';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchAvailableOptions(action: AvailableOptionActionType): Generator<*, *, *> {
  try {
    let options = yield call([tripica, 'getAvailableOptions']);
    options = injectMockRoamingCatalogOptions(options);
    if (action?.payload?.blackFriday) {
      const blackFridayOptions = {
        ...options,
        creditableOptions: {
          ...options.creditableOptions,
          DATA: options.creditableOptions.DATA.filter(option => option.name !== 'KAIZEN_OPTDATAUNL'),
        },
      };
      yield put(setAvailableOptions(blackFridayOptions));
    } else {
      yield put(setAvailableOptions(options));
    }
  } catch (e) {
    WizzeeLog.warn('[saga] fetchAvailableOptions', e);
    HandleErrorService.showToastError(e);
  }
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('FETCH_AVAILABLE_OPTIONS', fetchAvailableOptions)];
}
